class Accordion {
  /**
   * constructor
   */
  constructor() {
    this.cachDom();
    this.bindEvents();
  }

  cachDom(params) {
    this.questionsElement = document.querySelector('.c-faqBlock__render');
  }

  bindEvents(params) {
    if (_.isNull(this.questionsElement) === false) {
      this.questionsElement.addEventListener('click', this.delegate(this.buttonsFilter, this.buttonHandler).bind(this));
    }
  }

  buttonFilter(el) {
    return el.classList && el.classList.contains('c-faq__question');
  }

  buttonHandler(e) {
    let element = null;
    const button = e.delegateTarget;

    if (button.classList.contains('c-faq__item')) {
       element = button;
    } else if (button.classList.contains('c-faq__question')) {
      element = button.parentNode;
    } else {
       element = button.parentNode.parentNode;
    }

    if (!element.classList.contains('c-faq__answer--is-open')) {
      element.classList.add('c-faq__answer--is-open');
    } else {
      element.classList.remove('c-faq__answer--is-open');
    }
  }

  delegate(criteria, listener) {
    return function (e) {
      let el = e.target;
      do {
        // if (!criteria(el)) continue;
        e.delegateTarget = el;
        listener.apply(this, arguments);
        return;
      } while ((el = el.parentNode));
    };
  }
}

module.exports = Accordion;